module.exports = __webpack_public_path__ + "f3fde478a3e23155f70f0f579a8543f9.pdf";